/**
 * Every visit starts at the top of the page.
 *
 * The nav scrolls without writing to the URL, so a fragment can now only
 * arrive from outside: a bookmark, a history autocomplete, or a link copied
 * before that change. Honouring it drops the visitor into the middle of a
 * single-page site with no sense of what they skipped — worse here than on a
 * multi-page site, because there is no separate page to have arrived at.
 */
const dropHash = () => {
  if (window.location.hash) {
    window.history.replaceState(null, '', window.location.pathname)
  }
}

export const onClientEntry = () => {
  /* The browser restores the previous offset on reload and on reopening a
     tab. On one page that restore is the same disorientation by another
     route, so scroll position is not carried across loads. */
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }

  dropHash()
}

export const onInitialClientRender = () => {
  /* Again, because Gatsby's router syncs the location during hydration and
     puts the fragment back. Stripping it only here would leave the browser's
     own jump to run first, so both passes are needed. */
  dropHash()

  /* The browser has already acted on the fragment by now, so the scroll it
     caused has to be undone. 'instant' opts out of the smooth scrolling
     global.css turns on — without it the visitor watches the page glide up
     from wherever the stale fragment left them. */
  window.scrollTo({ top: 0, behavior: 'instant' })
}
